// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1357":"css/app.7086","7490":"css/admin-app.7086"}[chunkId] + ".css";
};